import { GoogleOAuthProvider } from '@react-oauth/google'
import { ToastContainer } from 'react-toastify'
import Routers from 'router'
import 'react-toastify/dist/ReactToastify.css'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { atenyaUser, loginTypeConst } from 'constant/const'
import { setLoginType, setUserDataLocal } from 'store/action/AuthRedux'
import 'react-datepicker/dist/react-datepicker.css'

function App() {
   const dispatch = useDispatch()

   useEffect(() => {
      let user = localStorage.getItem(atenyaUser)
      let loginT = localStorage.getItem(loginTypeConst)
      if (user) {
         let userData = JSON.parse(user)
         dispatch(setUserDataLocal(userData))
      }
      if (loginT) {
         dispatch(setLoginType(loginT))
      }
      return () => {}
   }, [])

   return (
      <>
         <div className="destop-show">
            <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_KEY}>
               <ToastContainer />
               <Routers />
            </GoogleOAuthProvider>
         </div>
         {/* <div className="mobile-show at-text-dark">Coming soon for responsive devices</div> */}
      </>
   )
}

export default App
